(function () {
  'use strict';

  angular
    .module('unit.cancel.deal')
    .directive('unitCancelDeal', unitCancelDeal);

  unitCancelDeal.$inject = ['UnitCancelDealService'];

  function unitCancelDeal(UnitCancelDealService) {
    var directive = {
      bindToController: true,
      link: link,
      restrict: 'A',
      scope: {
        titleText: '@titleText',
        onCancel: '&onCancel',
        onBack: '&onBack',
        dealId: '=dealId',
      },
    };
    return directive;

    function link(scope, element, attrs) {
      element.bind('click', function (e) {
        UnitCancelDealService.show(scope);
      });
    }
  }
})();
